import TickIcon from "../../../assets/Icons/tickIcon.svg";
import ActiveIcon from "../../../assets/Icons/ActiveIcon.svg";

const SignUpSteps = ({ activeStep, onBoardingSteps = [
  "Register with Mobile No.",
  "Add your PAN card",
  "e-KYC",
  "Loan Application",
] }) => {
  return (
    <div className="flex flex-col gap-[10px]">
      {onBoardingSteps.map((step, index) => {
        let icon = null;
        let textColor = "text-black";
        // Determine the icon and text color based on the step state
        if (index < activeStep) {
          icon = <img src={TickIcon} alt="Completed" />;
          textColor = "text-[#424952]"; // Completed step color
        } else if (index === activeStep) {
          icon = <img src={ActiveIcon} alt="Active" />;
          textColor = "text-[#00C08B]"; // Active step color
        } else {
          textColor = "text-[#878889]";
        }

        return (
          <p
            key={index}
            className={`font-Apparat font-semibold text-[14px] leading-[20px] tracking-[-0.02em] flex gap-2 items-center  ${index > activeStep ? "ms-[20px]" : ""
              } ${textColor}`}
          >
            {icon && <span className="w-[14px]">{icon}</span>}
            {step}
          </p>
        );
      })}
    </div>
  );
};

export default SignUpSteps;
